export default {
	document_buzzwords_label: 'Keywords',
	document_category_create_error: 'The category could not be created.',
	document_category_created: 'The category was created.',
	document_category_global_hint: 'global',
	document_category_label: 'Category',
	document_category_new_button: 'New category',
	document_category_new_dialog_title: 'Create new category',
	document_category_new_for_ido: 'For this record',
	document_category_new_global: 'For all records (global)',
	document_category_new_name_label: 'Category name',
	document_category_new_scope_label: 'Applies to',
	document_category_none: 'No category',
	document_create_dialog_camera: 'Camera',
	document_create_dialog_cancel: 'Cancel',
	document_create_dialog_create_new_document: 'Create new documents',
	document_create_dialog_create_new_document_source: 'Source',
	document_create_dialog_mediathek: 'Media library',
	document_create_dialog_select_files: 'Select files',
	document_create_dialog_selected_files: 'Selected file',
	document_create_dialog_upload_error: 'The document could not be uploaded.',
	document_create_dialog_upload_file: 'Upload file',
	document_create_dialog_upload_files: 'Upload files',
	document_create_dialog_uploading: 'Uploading …',
	document_default_postbox_label: 'Default postbox',
	document_delete_dialog_confirm_cancel_label: 'No',
	document_delete_dialog_confirm_message: 'Do you really want to delete this document?',
	document_delete_dialog_confirm_ok_label: 'Yes',
	document_delete_dialog_confirm_title: 'Delete document',
	document_delete_failed_notification: 'Document could not be deleted',
	document_download: 'Download',
	document_download_to_documents_successful: 'The file was successfully loaded into the Documents folder',
	document_external_share_active: 'Active',
	document_external_share_apply: 'Apply',
	document_external_share_cancel: 'Cancel',
	document_external_share_copied: 'Link copied',
	document_external_share_copy: 'Copy link',
	document_external_share_copy_failed: 'Copying failed — please select and copy the link manually.',
	document_external_share_delete: 'Delete link',
	document_external_share_delete_confirm_header: 'Delete link?',
	document_external_share_delete_confirm_message:
		'The link becomes invalid immediately. Links you already sent will stop working.',
	document_external_share_delete_failed: 'The link could not be deleted.',
	document_external_share_deleted: 'Link deleted',
	document_external_share_discard_confirm_message: 'Discard changes that have not been applied?',
	document_external_share_download_notice: 'The document author is notified about every external download.',
	document_external_share_empty_description:
		'Anyone who receives the link can download the file without signing in. Optionally protect the link with a password and an expiry date.',
	document_external_share_empty_headline: 'Share this document via link',
	document_external_share_expired_on: 'Expired on {date}',
	document_external_share_generate: 'Create link',
	document_external_share_generate_failed: 'The link could not be created.',
	document_external_share_link_label: 'Link',
	document_external_share_menu_external: 'Share externally',
	document_external_share_menu_internal: 'Share',
	document_external_share_password: 'Password',
	document_external_share_settings_save_failed: 'The settings could not be saved.',
	document_external_share_settings_saved: 'Settings saved',
	document_external_share_share_link: 'Share link…',
	document_external_share_title: 'Share externally',
	document_external_share_valid_until: 'Valid until',
	document_external_share_valid_until_hint: 'Empty = valid indefinitely',
	document_file_label: 'File',
	document_pdf_zoom: 'PDF zoom',
	document_pdf_zoom_in: 'Zoom PDF in',
	document_pdf_zoom_out: 'Zoom PDF out',
	document_pdf_zoom_value: 'Zoom {value}%',
	document_postbox_label: 'Document storage',
	document_preview_load_failed: 'The preview could not be loaded',
	document_save_failed_notification: 'Document could not be saved',
	document_saved_notification: 'Document saved',
	document_share: 'Share…',
	document_title_label: 'Document title',
	document_upload_tray_dismiss: 'Dismiss',
	document_upload_tray_failed: 'Failed',
	document_upload_tray_failed_title: '{failed} of {total} failed',
	document_upload_tray_phase_preparing: 'Preparing …',
	document_upload_tray_phase_processing: 'Processing …',
	document_upload_tray_retry: 'Retry',
	document_upload_tray_title: 'Uploading {current} of {total}',
	document_upload_tray_toggle: 'Show files',
	document_version_author: 'Author',
	document_version_delete: 'Delete version',
	document_version_delete_failed: 'The version could not be deleted.',
	document_version_delete_initial_not_possible: 'The original version cannot be deleted',
	document_version_dialog_camera: 'Camera',
	document_version_dialog_cancel: 'Cancel',
	document_version_dialog_confirm_cancel_label: 'No',
	document_version_dialog_confirm_message: 'Do you really want to delete this version?',
	document_version_dialog_confirm_ok_label: 'Yes',
	document_version_dialog_confirm_title: 'Delete document version',
	document_version_dialog_create_new_document: 'Set new version',
	document_version_dialog_create_new_document_source: 'Source',
	document_version_dialog_mediathek: 'Media library',
	document_version_dialog_select_files: 'Select file',
	document_version_dialog_selected_files: 'Selected',
	document_version_dialog_upload_error: 'The document version could not be uploaded.',
	document_version_dialog_upload_file: 'Upload file',
	document_version_dialog_upload_files: 'Upload files',
	document_version_dialog_uploading: 'Uploading …',
	document_version_download: 'Download version',
	document_version_drag_message: 'Drag & Drop document here',
	document_version_drop_message: 'Drop document',
	document_version_filename: 'Filename',
	document_version_filesize: 'Filesize',
	document_version_selected_new_document: 'Select document',
	document_version_time: 'Time',
	document_version_title: 'Document Versions',
	document_version_version: 'Version',
	document_version_versions: 'Versions',
};
